import qs from 'qs';
import moment from 'moment';
import api from './api';
import generateSearchRequest from '../utils/sequelize-search-builder-client';

const selectPlan = (plan) => {
	return {
		...plan,
		createdAt: plan.createdAt ? moment(plan.createdAt).toDate() : null,
		updatedAt: plan.updatedAt ? moment(plan.updatedAt).toDate() : null,
	};
};

const selectPlans = (plans) => plans.map(selectPlan);

class PlanService {
	async createPlan(planForm) {
		return api.post('/plans', planForm)
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					'fail when trying to create plan in PlanService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getAllEnabled({ page = 0, size = 10 }) {
		return api
			.get('/plans', {
				params: {
					page,
					size,
				},
			})
			.then((response) => response.data)
			.then((data) => ({ ...data, body: selectPlans(data.body) }))
			.catch((error) => {
				console.log('fail when trying to get plans in PlanService.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async getAll({ page = 0, size = 10, order, filters }) {
		const settings = {
			where: {
				id: {
					as: 'id',
					type: 'like',
				},
				name: {
					as: `name`,
					type: 'like',
				},
				amount: {
					as: `amount`,
					type: 'like',
				},
				'createdAt:between': {
					as: 'createdAt',
					type: 'between',
				},
			},
			order,
		};
		const request = generateSearchRequest(filters, settings);
		return api
			.get('/plans/all', {
				paramsSerializer: {
					serialize: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
				},
				params: {
					page,
					size,
					...request,
				},
			})
			.then((response) => response.data)
			.then((data) => ({ ...data, body: selectPlans(data.body) }))
			.catch((error) => {
				console.log('fail when trying to get plans in PlanService.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async getPlanByClientId(clientId) {
		return api
			.get(`/plans/by/${clientId}`)
			.then((response) => response.data)
			.catch((error) => {
				console.log('fail when trying to get plan in PlanService.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async getByName(planName) {
		return api
			.get(`/plans?filter[name][eq]=${planName}`)
			.then((response) => response.data)
			.then((data) => data.body[0])
			.then(selectPlan)
			.catch((error) => {
				console.log('fail when trying to get plan in PlanService.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}
}

const planService = new PlanService();
export default planService;
